import type { ProfileDto, ProfilePatch } from '../../api/know'

/**
 * Armado del body de `PATCH /know/me/profile` desde el estado del formulario
 * de perfil (`KnowProfile`, reusado por `TabletProfile`).
 *
 * El wizard guarda una sola vez, en la última pregunta, así que cualquier
 * campo inválido del payload aparece como error recién ahí. Dos reglas
 * evitan que eso pase con campos que el formulario no pregunta ni puede
 * corregir:
 *
 * - `email` viaja sólo si el perfil tiene uno. El backend rechaza un email
 *   vacío con 400 ("Email inválido.") y el DTO devuelve `null` para los users
 *   creados sin email por `/auth/register`, así que reenviarlo tal cual hacía
 *   imposible guardar el perfil (bug reportado 2026-09-18: "no me deja dejar
 *   vacía la última pregunta y falla").
 * - los opcionales de texto vacíos viajan como `null`, no como `""`, para que
 *   el backend guarde NULL. Es el caso de `vision_notes`, cuyo placeholder
 *   dice explícitamente que se puede dejar vacío.
 *
 * El resto de los campos viaja tal cual está en el formulario: el contrato
 * (vocabularios cerrados, rangos de edad y altura) no cambia.
 */
export function buildProfilePatch(profile: ProfileDto): ProfilePatch {
  const patch: ProfilePatch = {
    display_name: profile.display_name,
    handedness: profile.handedness,
    dominant_foot: profile.dominant_foot,
    height_cm: profile.height_cm,
    age: profile.age,
    gender: profile.gender,
    position: profile.position,
    vr_experience: profile.vr_experience,
    vision_notes: blankToNull(profile.vision_notes),
  }
  const email = profile.email?.trim()
  if (email) patch.email = email
  return patch
}

function blankToNull(value: string | null): string | null {
  const trimmed = value?.trim()
  return trimmed ? trimmed : null
}
